import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateDirective } from '../../../../../../components/Utilites/Directives/translate.directive';

interface Submission {
  submissionId: number;
  studentName: string;
  rollNumber: string;
  status: string;
  submittedOn: string;
  marks: number | null;
}

@Component({
  selector: 'app-submission-view',
  imports: [
    MatCardModule,
    MatDividerModule,
    MatTableModule,
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    TranslateDirective
  ],
  templateUrl: './submission-view.component.html',
  styleUrls: ['./submission-view.component.scss'],
})
export class SubmissionViewComponent {
  classId: string | null = null;
  userId: string | null = null;
  assignmentId: string | null = null;
  statKeys: (keyof typeof this.data.stats)[] = [
    'totalStudents',
    'submitted',
    'pending',
    'lateSubmission',
  ];

  // All static data in one object
  data = {
    headerInfo: {
      reg: '2024 - 2027',
      course: 'MPC',
      semester: '3rd Sem',
      subject: 'English',
      section: 'A',
      deadline: '31 May 2025',
    },
    stats: {
      totalStudents: 45,
      submitted: 38,
      pending: 7,
      lateSubmission: 3,
    },
    submissions: <Submission[]>[
      {
        submissionId: 232,
        studentName: 'Kiran Reddy',
        rollNumber: '2024dbr001',
        status: 'Submitted',
        submittedOn: '27 May 2025',
        marks: null,
      },
      {
        submissionId: 233,
        studentName: 'Ananya Sharma',
        rollNumber: '2024dbr002',
        status: 'Pending',
        submittedOn: '28 May 2025',
        marks: null,
      },
      {
        submissionId: 234,
        studentName: 'Rohit Verma',
        rollNumber: '2024dbr003',
        status: 'Approved',
        submittedOn: '29 May 2025',
        marks: 8,
      },
      {
        submissionId: 235,
        studentName: 'Sneha Iyer',
        rollNumber: '2024dbr004',
        status: 'Rejected',
        submittedOn: '30 May 2025',
        marks: null,
      },
      {
        submissionId: 236,
        studentName: 'Vikram Joshi',
        rollNumber: '2024dbr005',
        status: 'Submitted',
        submittedOn: '01 June 2025',
        marks: null,
      },
      {
        submissionId: 235,
        studentName: 'Pooja Gupta',
        rollNumber: '2024dbr006',
        status: 'Pending',
        submittedOn: '02 June 2025',
        marks: null,
      },
    ],
  };

  displayedColumns: string[] = [
    'studentName',
    'rollNumber',
    'status',
    'submittedOn',
    'marks',
    'actions',
  ];

  constructor(private _router: Router, private router: ActivatedRoute) {}

  ngOnInit() {
    this.classId = this.router.snapshot?.paramMap.get('classId');
    this.userId = this.router.snapshot?.paramMap.get('staffId');
    this.assignmentId = this.router.snapshot?.paramMap.get('assignmentId');
  }

  onView(submission: Submission): void {
    this._router.navigate([
      `/assignments/staff/${this.userId}/${this.classId}/${this.assignmentId}/submissionspage/${submission.submissionId}`,
    ]);
  }

  goBack() {
    this._router.navigate([
      `/assignments/staff/${this.userId}/${this.classId}/${this.assignmentId}`,
    ]);
  }
}
